import { Reveal } from "@/components/Reveal";

export const SectionHeader = ({ label, title, subtitle, align = "center", dark = false }) => {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <Reveal className={`max-w-[640px] ${align === "center" ? "mx-auto text-center" : ""} mb-12 lg:mb-16`}>
      <p className="micro-label mb-4" style={dark ? { color: "rgba(255,255,255,0.7)" } : undefined}>{label}</p>
      <h2 className={`font-heading font-bold text-3xl sm:text-4xl lg:text-[44px] leading-[1.1] ${dark ? "text-white" : "text-brand-deep"} ${alignCls}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-base md:text-lg max-w-[560px] ${dark ? "text-white/75" : "text-ink-secondary"} ${align === "center" ? "mx-auto" : ""}`}>
          {subtitle}
        </p>
      )}
    </Reveal>
  );
};
